<template>
    <div class="batch-dispatch-comp">
        <div class="left table-list">
            <div class="mask"></div>
            <div v-if="housesCid.length" class="selected-tips">
                <div class="wording">
                    已選取 {{housesCid.length}} 個房源
                </div>
            </div>
            <div v-if="this.filterTag.length" class="filter-tips">
                <span class="result">
                    {{filterByWord.length}} 個結果
                </span>
                <span class="item" v-for="(item, index) in this.filterTag" :key="index">
                    {{item}}
                </span>
            </div>
            <div class="table-list-title">
                <span class="checkbox" @click="clearSuccessFlag">
                    <checkbox v-model="checkboxStatus.checkboxAll"  :isPropChecked="checkboxStatus.checkboxAll"></checkbox>
                </span>
                <span class="address">地址</span>
                <span class="landlord">房東</span>
                <span class="sales">分區/業務</span>
            </div>
            <div class="table-list-body">
                <div v-if="isLoading" class="filter-empty">
                    <table-loading />
                </div>
                <div v-else-if="filterByWord.length == 0 && batchDispatchList.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
                </div>
                <div v-else-if="batchDispatchList.length == 0" class="is-empty">0 筆資料</div>
                <ul v-else>
                    <li v-for="(list,index) in filterByWord" :key="index" @click="selectedId = list.houseId, selectedIndex = index">
                        <span class="checkbox" @click="clearSuccessFlag">
                            <checkbox v-if="list.houseStatus !== 'LOCK' && !list.arrears" :val="list.houseId" v-model="housesCid" :isPropChecked="checkboxStatus.checkboxAll || checkboxStatus.forceUpdate"></checkbox>
                        </span>
                        <span class="address">
                            {{list.address.length >= 15?compressWord(list.address, 15):list.address}}
                            <div v-if="list.address.length >= 15" class="full-word">
                                <span>
                                    {{list.address}}
                                </span>
                            </div>
                        </span>
                        <span v-if="list.houseStatus !== 'LOCK' && !list.arrears" class="landlord">
                            <select-landlord :isPhone="false" :msg="list.landlordName?list.landlordName:'請選擇房東'" @getLandlordId="setLandlordId"></select-landlord>
                        </span>
                        <span v-else class="landlord" @click="eventRules(list, '房東')">
                            <span class="disable">
                                {{list.agentName?list.landlordName:'請選擇房東'}}
                            </span>
                        </span>
                        <span v-if="list.houseStatus !== 'LOCK' && !list.arrears" class="sales">
                            <select-group v-if="isAllGroup" :msg="list.groupName?list.groupName:'請選擇區域'" @getId="setGroupId"></select-group>
                            <select-sales :msg="list.agentName?list.agentName:'請選擇業務'" @getId="setSalesId" @click.native="getSingelRowSales(list.groupId)"></select-sales>
                        </span>
                        <span v-else class="sales" @click="eventRules(list, '業務')">
                            <span v-if="isAllGroup" class="disable">
                                {{list.groupName?list.groupName:'請選擇區域'}}
                            </span>
                            <span class="disable">
                                {{list.agentName?list.agentName:'請選擇業務'}}
                            </span>
                        </span>
                        <span v-if="successFlag[index]">
                            <img src="@/assets/img/icon/success_done.svg" alt="">
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <batch-dispatch-filter></batch-dispatch-filter>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import batchDispatchFilter from '@/components/bussiness/mgtCategory/houseMgt/batchDispatch/batchDispatchFilter.vue';
import selectLandlord from '@/components/bussiness/mgtCategory/houseMgt/addHouse/selectLandlord.vue';
import selectGroup from '@/components/bussiness/widges/input/selectGroup.vue';
import selectSales from '@/components/bussiness/widges/input/selectSales.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            selectedIndex: null,
            selectedId: null,
            checkboxStatus: {
                checkboxAll: false,
                forceUpdate: null
            },
            housesCid: [],
            successFlag: [],
            isLoading: true
        }
    },
    created () {
        this.$store.dispatch('getBizBatchDispatchList')
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        checkboxStatus: {
            handler: function (val) {
                console.log(val)
                setTimeout(()=>{
                    this.$store.dispatch('setBizBatchDispatchCheckboxStatus', val)
                },500)
            },
            deep: true
        },
        housesCid: {
            handler: function (val) {
                this.$store.dispatch('setBizBatchDispatchSeletedHouse', val)
                if(val.length === 0){
                    this.checkboxStatus.checkboxAll = false
                }else if(this.filterByWord.length === val.length){
                    this.checkboxStatus.checkboxAll = true
                }
            },
            deep: true
        },
        filterQueryUpdate: function () {
            this.clearCheckbox()
        },
        'checkboxStatus.checkboxAll': function (val) {
            let list = this.filterByWord
            if(val){
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(!this.housesCid.includes(element.houseId)){
                        this.housesCid.push(element.houseId)
                    }
                }
            }else{
                this.housesCid = []
            }
        },
        successList: function (val) {     
            this.clearCheckbox()
            for (let i = 0; i < this.filterByWord.length; i++) {
                const element = this.filterByWord[i];
                if(val.includes(this.filterByWord[i].houseId)){
                    this.successFlag[i] = true
                }
            }
        }
    },
    methods: {
        eventRules: function (list, type) {
            // console.log(list)
            if(list.houseStatus === 'LOCK'){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '預定時不得更換'+type ,type: 'error', closeBtn: true})
            }else if(list.arrears){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得更換'+type ,type: 'error', closeBtn: true})
            }
            // let arrears = true
            // let arrears = this.houseDefault.arrears
            // if(arrears && event === 'arrears'){
            //     this.$store.dispatch('setAlarmStatus', {status: true,title: msg,type: 'error', closeBtn: true})
            // }
        },
        setLandlordId: function (value){
            let data = {
                "houseId": this.selectedId,
                "landlordId": value,
            }
            this.updateSingleDispatch(data, '成功替換房東')
        },
        setGroupId: function (value) {
            let data = {
                "houseId": this.selectedId,
                "groupId": value,
            }
            this.updateSingleDispatch(data, '成功替換群組')
        },
        setSalesId: function (value) {
            let groupId = this.filterByWord[this.selectedIndex].groupId
            if(this.filterByWord[this.selectedIndex].groupId){
                let data = {
                    "houseId": this.selectedId,
                    "groupId": groupId,
                    "agentId": value
                }
                this.updateSingleDispatch(data, '成功替換業務')
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請先選擇業務群組',type: 'error'})
            }
            
        },
        updateSingleDispatch: function (data, msg) {
            this.$store.dispatch('updateBizSingleDispatch', data)
            .then(()=>{
                this.$store.commit('batchDispatch/set_success_list', [this.selectedId])
                this.$store.dispatch('setAlarmStatus', {status: true,title: msg,type: 'success'})
            })
        },
        getSingelRowSales: function (groupId) {
            if(groupId){
                this.$store.dispatch('getBizDispatchMemberByGroupList', groupId)
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請先選擇業務群組',type: 'error'})
                this.$store.commit('batchDispatch/set_member_by_group', [])

            }
        },
        clearCheckbox: function () {
            this.checkboxStatus.forceUpdate = false
            this.housesCid = []
            setTimeout(()=>{
                this.checkboxStatus.forceUpdate = null
            }, 500)
        },
        clearSuccessFlag: function () {
            this.successFlag = []
        }
    },
    computed: {
        filterByCounty: function () {
            return this.batchDispatchList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.city === this.filterQuery.county){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district === this.filterQuery.district){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByAddressCompleted: function () {
            return this.filterByDistrict.filter((item) => {
                if(this.filterQuery.addressCompleted){
                    if(item.addressComplete == this.filterQuery.addressCompleted){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByAddressCompleted.filter((item) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == item.houseType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((item) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == item.buildingType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByBuildingType.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByNoSales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.noSales){
                    if(item.agentId === null){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByNoSales.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLandlord: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.landlord){
                    if(item.landlordName == this.filterQuery.landlord){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByNoLandlord: function () {
            return this.filterByLandlord.filter((item) => {
                if(this.filterQuery.noLandlord){
                    if(item.landlordId === null){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByNoLandlord.filter((item) => {
                this.filterQueryUpdate
                if( this.filterQuery.word ){
                    if( item.address.includes(this.filterQuery.word) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterTag: function () {
            let filterTag = []
            let index = 0
            for( var item in this.filterQuery ){
                let filterValue = this.filterQuery[item]
                if(filterValue && item != 'countyId'){
                    filterValue = this.transFilterTagContent(item, filterValue)
                    if( item == 'noSales' || item == 'noLandlord' || item == 'addressCompleted'){
                        filterTag[index] = this.transFilterTagTitle(item)
                    }else{
                        filterTag[index] = this.transFilterTagTitle(item)+'：'+filterValue
                    }
                    index++
                }
            }
            return filterTag
            
        },
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            batchDispatchList: 'GET_BIZ_BATCH_DISPATCH_LIST',
            filterQuery: 'GET_BIZ_BATCH_DISPATCH_FILTER_QUERY',
            filterQueryUpdate: 'GET_BIZ_BATCH_DISPATCH_FILTER_QUERY_UPDATE',
            successList: 'GET_BIZ_BATCH_DISPATCH_SUCCESS_LIST',
            // housesCid: 'GET_BIZ_BATCH_DISPATCH_SELECTED_HOUSE_CID',
        })
    },
    components: {
        Checkbox,
        batchDispatchFilter,
        selectLandlord,
        selectGroup,
        selectSales,
        tableLoading
    }
}
</script>
<style lang="scss">
    .batch-dispatch-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .table-list{
            width: 850px;
            .table-list-title{
                padding: 16px;
                .sales{
                    justify-content: flex-start;
                }
            }
            .table-list-body >ul >li{
                padding: 16px;
            }
            .checkbox{
                width: 20px;
                margin-right: 16px;
            }
            .address{
                width: 220px;
                margin-right: 48px;
            }
            .disable{
                display: flex;
                align-items: center;
                width: 140px;
                height: 36px;
                border-radius: 4px;
                border: solid 1px #e0dfde;
                background-color: #f0f0f0;
                color: #c5c2c1;
                box-sizing: border-box;
                padding: 0 16px;
            }
            .landlord{
                width: 142px;
                margin-right: 48px;
                span{
                    display: flex !important;
                }
                .select-landlord{
                    padding: 9px 16px;
                    .select-filter{
                        width: 206px;
                    }
                    >ul{
                        width: 206px;
                        >li{
                            box-sizing: border-box;
                            .radio{
                                width: 100%;
                                .input-radio{
                                    box-sizing: border-box;
                                }
                            }
                        }
                    }
                }
            }
            .sales{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 290px;
                margin-right: 20px;
                .select-item{
                    width: 140px;
                }
                
            }
        }
    }
    .page-setting.fixed .batch-dispatch-comp .table-list .table-list-title {
        position: relative;
        top: unset;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/batchDispatch/batchDispatchComp.vue